import type { IFormSettings, TFormType } from '@entities/form';

export const FORM_SETTINGS_KEYS: (keyof IFormSettings)[] = [
  'has_cancel',
  'has_order',
  'has_timer',
  'has_loader',
  'has_payment_processing_timer',
  'payment_processing_timer',
  'has_collapse_wallet_details',
  'has_wallet_holder_name',
  'has_wallet_bank_code',
  'has_qrcode',
  'has_qr_download',
  'has_method_logo',
  'has_deeplink',
  'has_instruction',
  'has_wallet_address',
  'has_payment_warning',
  'show_deposit_amount_warning',
  'show_utr_exit_warning',
  'has_socket_order_monitoring',
  'has_expiration_time',
  'form_type',
  'expiration_time',
  'has_slip_loader',
  'show_localization',
  'has_autoredirect_on_success',
  'autoredirect_on_success_timer',
];

const DEFAULT_FORM_TYPE = 'basic';

export const assmebleFormSettings = (fd: FormData) => {
  return FORM_SETTINGS_KEYS.reduce((acc, key) => {
    switch (key) {
      case 'form_type':
        acc[key] = (fd.get(key) as TFormType) ?? DEFAULT_FORM_TYPE;
        break;
      case 'payment_processing_timer':
      case 'autoredirect_on_success_timer':
        acc[key] = Number(fd.get(key)) || 0;
        break;
      case 'expiration_time':
        acc[key] = Number(fd.get(key)) || 600;
        break;
      default:
        acc[key] = fd.get(key) === 'true';
    }
    return acc;
  }, {} as IFormSettings);
};
